import { render, staticRenderFns } from "./ViewCompanyDocuments.vue?vue&type=template&id=ea56c508&"
import script from "./ViewCompanyDocuments.vue?vue&type=script&lang=js&"
export * from "./ViewCompanyDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports